import React, { Suspense } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ThemeConfig from "./Theme/ThemeConfig";
import Router from "./routes";
import Loader from "./Components/Loader";


function App() {

  return (
    <ThemeConfig>
      <ToastContainer
        autoClose={5000}
        position="top-right"
        theme="light"
        hideProgressBar={true}
      />
      <Suspense fallback={<Loader open={true}/>}>
      <Router />
      </Suspense>
    </ThemeConfig>
  );
}

export default App;
